import { useContext, useMemo } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import * as SaveAsNewSegmentDialog from 'components/filter/filters-next/SaveAsNewSegmentDialog';
import { transformSavedFilterGroups } from 'components/filter/filters-next/downstream';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { deepSanitizeFilterGroups } from 'components/filter/filters-next/util';
import { useCurrentSegment } from 'customHooks/useCurrentSegment';
import { isEqual } from 'lodash';

const SaveNewSegmentButton = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { filterGroups } = useFiltersByKey(cacheKey);
    const isViewingSegment = useCurrentSegment();

    const hasDiff = useMemo(
        () =>
            !isEqual(
                deepSanitizeFilterGroups(
                    transformSavedFilterGroups(isViewingSegment?.filters ?? []),
                ),
                deepSanitizeFilterGroups(filterGroups),
            ),
        [filterGroups, isViewingSegment?.filters],
    );

    if (!hasDiff || !!isViewingSegment) {
        return null;
    }

    return (
        <SaveAsNewSegmentDialog.Root>
            <SaveAsNewSegmentDialog.Trigger>
                <Button size={'sm'} variant={'outline'} color={'neutral'} onClick={() => {}}>
                    <FontAwesomeIcon icon={faSave} />
                    Save as segment
                </Button>
            </SaveAsNewSegmentDialog.Trigger>
        </SaveAsNewSegmentDialog.Root>
    );
};

export { SaveNewSegmentButton };
